module.exports = __webpack_public_path__ + "images/Introduction.pdf?v=e714e7b97006696e4da19bccb0bd8996";